<template>
  <v-container><h1>Resource Unavailable</h1></v-container>
</template>

<script>
export default {
  name: "ResourceUnavailable"
};
</script>
